import { DefaultTableTypeAbstract } from "./DefaultTableTypeAbstract";

export class DefaultTableTypeMin50BB extends DefaultTableTypeAbstract {
}
